import React from "react";
import TablesFactures from "./features/TablesFactures";
import { Help } from "src/utils";
import { NumberToLetter } from "@mandarvl/convertir-nombre-lettre";
import { SectionFacture } from "../../compoments/ModalDelete";

export default function FactureCaution({
  cost,
  nombre_mois_caution,
  nombre_mois_avance,
  calculeTotal,
}) {
  const infoDataTableHead = [
    {
      libelle: "LIBELLE",
    },
    {
      libelle: "MONTANT UNITAIRE",
    },
    {
      libelle: "UNITE",
    },
    {
      libelle: "TOTAL",
    },
  ];
  const infoDataTableBody = [
    {
      coloneTd: [
        {
          libelle: `LOYER : (MONTANT DU LOYER CAUTION DE ${nombre_mois_caution}
                  MOIS :)`,
        },
        {
          libelle: Help.convertInMoney(Number(cost)),
        },
        {
          libelle: nombre_mois_caution,
        },
        {
          libelle: Help.convertInMoney(
            Number(cost) * Number(nombre_mois_caution)
          ),
        },
      ],
    },
    {
      coloneTd: [
        {
          libelle: `AVANCE DU LOYER ${nombre_mois_avance ? nombre_mois_avance : 0}
                  MOIS`,
        },
        {
          libelle: Help.convertInMoney(Number(cost)),
        },
        {
          libelle: nombre_mois_avance ? nombre_mois_avance : 0,
        },
        {
          libelle: nombre_mois_avance
            ? Help.convertInMoney(Number(cost) * Number(nombre_mois_avance))
            : 0,
        },
      ],
    },
    {
      coloneTd: [
        {
          libelle: "FRAIS D’AGENCE",
        },
        { libelle: Help.convertInMoney(Number(cost)) },
        { libelle: 1 },
        { libelle: Help.convertInMoney(Number(cost)) },
      ],
    },
    {
      coloneTd: [
        {
          libelle: `FRAIS DE DOSSIER (10% DU LOYER)`,
        },
        {
          libelle: Help.convertInMoney((Number(cost) * 10) / 100),
        },
      ],
    },
    {
      coloneTd: [
        {
          libelle: `TOTAL A PAYER`,
          colSpan: 3,
          style: "text-left",
        },
        {
          libelle: Help.convertInMoney(
            calculeTotal(nombre_mois_avance, cost, nombre_mois_caution)
          ),
        },
      ],
    },
  ];
  return (
    <section className="my-5">
      <TablesFactures
        infoDataTableBody={infoDataTableBody}
        infoDataTableHead={infoDataTableHead}
      />
      <SectionFacture
        styleName={"px-5 my-5"}
        DataParagaphe={[
          {
            libelle: ` Arrêtée la présente facture à la somme de : `,
          },
          {
            libelle: `${NumberToLetter(
              calculeTotal(nombre_mois_avance, cost, nombre_mois_caution)
            )}`,
            styleParagraphe: "facture_in_somme text-secondary",
          },
        ]}
      />
    </section>
  );
}
